import {useCallback, useState} from 'react';
import useSessionTimed from './useSessionTimed';

export interface UseSessionTimedPerQuestionReturn {
  timeRemaining: number;
  startTimer: () => void;
  stopTimer: () => void;
}

export default function useSessionTimedPerQuestion(
  durationSeconds?: number,
  onTimeUp?: () => void,
): UseSessionTimedPerQuestionReturn {
  const [startTime, setStartTime] = useState<string | undefined>(undefined);

  // Use the base timed hook
  const {timeRemaining} = useSessionTimed(startTime, durationSeconds, onTimeUp);

  // Function to start or reset timer
  const startTimer = useCallback(() => {
    if (durationSeconds === undefined || durationSeconds < 1) {
      return; // Timer is disabled
    }

    // Set the start time to now
    setStartTime(new Date().toISOString());
  }, [durationSeconds]);

  // Function to stop timer
  const stopTimer = useCallback(() => {
    setStartTime(undefined);
  }, []);

  return {
    timeRemaining,
    startTimer,
    stopTimer,
  };
}
